import { ProductOffering } from '@apps/card/routes/Dashboard/components/ConciergeServiceSection/ConciergeServiceSection.types';

type ProductMetadataItem = Readonly<Pick<ProductOffering, 'identifier' | 'shortName' | 'longName'>>;
type ProductMetadata = ReadonlyArray<ProductMetadataItem>;

const generateProductMetadataWithIds = (metadata: ProductMetadata): Record<string, Readonly<ProductMetadataItem & { id: string }>> => {
  const result: Record<string, Readonly<ProductMetadataItem & { id: string }>> = {};
  metadata.forEach(item => {
    result[item.identifier] = { ...item, id: item.identifier };
  });
  return result;
};

const INVITATION_IDENTIFIERS: ProductMetadata = [
  { identifier: 'julyTrifold', shortName: 'July Trifold', longName: 'July Trifold Wedding Invitation Suite' },
  { identifier: 'wildestDream', shortName: 'Wildest Dreams', longName: 'Wildest Dreams Wedding Invitation Suite' },
  { identifier: 'together', shortName: 'Together', longName: 'Together Wedding Invitation Suite' },
  { identifier: 'sofia', shortName: 'Sofia', longName: 'Sofia Wedding Invitation Suite' },
  { identifier: 'sage', shortName: 'Sage', longName: 'Sage Wedding Invitation Suite' },
  { identifier: 'milkAndHoney', shortName: 'Milk and Honey', longName: 'Milk and Honey Wedding Invitation Suite' },
  { identifier: 'jardin', shortName: 'Jardin', longName: 'Jardin Wedding Invitation Suite' },
  { identifier: 'ivory', shortName: 'Ivory', longName: 'Ivory Wedding Invitation Suite' },
  { identifier: 'harmony', shortName: 'Harmony', longName: 'Harmony Wedding Invitation Suite' },
  { identifier: 'harmonyGatefold', shortName: 'Harmony Gatefold', longName: 'Harmony Gatefold Wedding Invitation Suite' },
  { identifier: 'empireNow', shortName: 'Empire Now', longName: 'Empire Now Wedding Invitation Suite' },
  { identifier: 'byronGatefold', shortName: 'Byron Gatefold', longName: 'Byron Gatefold Wedding Invitation Suite' },
  { identifier: 'celadon', shortName: 'Celadon', longName: 'Celadon Wedding Invitation Suite' },
  { identifier: 'wildMeadow', shortName: 'Wild Meadow', longName: 'Wild Meadow Wedding Invitation Suite' },
  { identifier: 'eden', shortName: 'Eden', longName: 'Eden Wedding Invitation Suite' },
  { identifier: 'luminous', shortName: 'Luminous', longName: 'Luminous Wedding Invitation Suite' },
  { identifier: 'graceTrifold', shortName: 'Grace Trifold', longName: 'Grace Trifold Wedding Invitation Suite' },
  { identifier: 'flutter', shortName: 'Flutter', longName: 'Flutter Wedding Invitation Suite' },
  { identifier: 'koffee', shortName: 'Koffee', longName: 'Koffee Wedding Invitation Suite' },
  { identifier: 'grace', shortName: 'Grace', longName: 'Grace Wedding Invitation Suite' },
  { identifier: 'roseEtGris', shortName: 'Rose et Gris', longName: 'Rose et Gris Wedding Invitation Suite' },
] as const;

const SAVE_THE_DATE_IDENTIFIERS: ProductMetadata = [
  { identifier: 'luna', shortName: 'Luna', longName: 'Luna Save the Date' },
  { identifier: 'linear', shortName: 'Linear', longName: 'Linear Save the Date' },
  { identifier: 'minimalisme', shortName: 'Minimalisme', longName: 'Minimalisme Save the Date' },
  { identifier: 'minimalistBlackWhite', shortName: 'Minimalist Black & White', longName: 'Minimalist Black & White Save the Date' },
  { identifier: 'polaroid', shortName: 'Polaroid', longName: 'Polaroid Save the Date' },
  { identifier: 'byron', shortName: 'Byron', longName: 'Byron Save the Date' },
  { identifier: 'summerMontage', shortName: 'Summer Montage', longName: 'Summer Montage Save the Date' },
  { identifier: 'delilah', shortName: 'Delilah', longName: 'Delilah Save the Date' },
  { identifier: 'floweret', shortName: 'Floweret', longName: 'Floweret Save the Date' },
  { identifier: 'summerNights', shortName: 'Summer Nights', longName: 'Summer Nights Save the Date' },
  { identifier: 'clairDeLune', shortName: 'Clair De Lune', longName: 'Clair De Lune Save the Date' },
] as const;

export const INVITATION_IDS = generateProductMetadataWithIds(INVITATION_IDENTIFIERS);
export const SAVE_THE_DATE_IDS = generateProductMetadataWithIds(SAVE_THE_DATE_IDENTIFIERS);
